import { Card, Col, Row, Statistic, Spin } from 'antd';
import {
  ClockCircleOutlined,
  CheckCircleOutlined,
  SyncOutlined,
  CloseCircleOutlined,
  FileTextOutlined,
} from '@ant-design/icons';
import { TransactionQueueStats } from '@mygate/common';

interface TransactionStatsProps {
  stats: TransactionQueueStats | null;
  loading: boolean;
}

export function TransactionStats({ stats, loading }: TransactionStatsProps) {
  if (loading) {
    return (
      <Card>
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <Spin size="large" />
        </div>
      </Card>
    );
  }

  if (!stats) {
    return null;
  }

  const formatAmount = (amount: string) => {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR',
    }).format(parseFloat(amount));
  };

  return (
    <Row className="operational-stats" gutter={[16, 16]} style={{ marginBottom: 24 }}>
      <Col xs={24} sm={12} xl={6}>
        <Card bordered={false} style={{ background: '#fff7e6' }}>
          <Statistic
            title="Pending Approval"
            value={stats.pending}
            prefix={<ClockCircleOutlined style={{ color: '#faad14' }} />}
            suffix={
              <span style={{ fontSize: 14, color: '#8c8c8c' }}>
                {stats.totalAmount.pending && formatAmount(stats.totalAmount.pending)}
              </span>
            }
          />
        </Card>
      </Col>

      <Col xs={24} sm={12} xl={6}>
        <Card bordered={false} style={{ background: '#e6f7ff' }}>
          <Statistic
            title="Approved"
            value={stats.approved}
            prefix={<FileTextOutlined style={{ color: '#1890ff' }} />}
            suffix={
              <span style={{ fontSize: 14, color: '#8c8c8c' }}>
                {stats.totalAmount.approved && formatAmount(stats.totalAmount.approved)}
              </span>
            }
          />
        </Card>
      </Col>

      <Col xs={24} sm={12} xl={6}>
        <Card bordered={false} style={{ background: '#f6ffed' }}>
          <Statistic
            title="Processing"
            value={stats.processing}
            prefix={<SyncOutlined style={{ color: '#52c41a' }} />}
            suffix={
              <span style={{ fontSize: 14, color: '#8c8c8c' }}>
                {stats.totalAmount.processing && formatAmount(stats.totalAmount.processing)}
              </span>
            }
          />
        </Card>
      </Col>

      <Col xs={24} sm={12} xl={6}>
        <Card bordered={false}>
          <Row>
            <Col span={12}>
              <Statistic
                title="Completed"
                value={stats.completed}
                prefix={<CheckCircleOutlined style={{ color: '#52c41a' }} />}
                valueStyle={{ fontSize: 20 }}
              />
            </Col>
            <Col span={12}>
              <Statistic
                title="Failed"
                value={stats.failed}
                prefix={<CloseCircleOutlined style={{ color: '#ff4d4f' }} />}
                valueStyle={{ fontSize: 20, color: '#ff4d4f' }}
              />
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  );
}
